<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportCsv"
                    v-can="'Activity.Export'"
                  >
                    <i class="ti ti-file-type-csv me-1"></i>Export CSV
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="mb-2">
            <a href="javascript:void(0);" @click="openCreate" class="btn btn-primary d-flex align-items-center" v-can="'Activity.Create'">
              <i class="ti ti-circle-plus me-2"></i>Add Activity
            </a>
          </div>

          <div class="ms-2 head-icons">
            <a href="javascript:void(0);" id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5>Activity List</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <ActivityTable ref="tableRef" @edit="openEdit" @delete="openDelete" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <ActivityModal ref="activityModalRef" @saved="onSaved" />
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted } from "vue";
import moment from "moment";
import { useCrmActivityStore } from "@/stores/crmActivityStore";
import ActivityTable from "./activity-table.vue";
import ActivityModal from "@/components/modal/activity-modal.vue";
import * as bootstrap from "bootstrap";

const title = "Activity";
const text = "CRM";
const text1 = "Activity List";

const tableRef = ref(null);
const activityModalRef = ref(null);
const store = useCrmActivityStore();

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function openCreate() {
  activityModalRef.value?.openForCreate();
  const el = document.getElementById("add_activity");
  if (el) new bootstrap.Modal(el).show();
}

async function openEdit(id) {
  await activityModalRef.value?.openForEditFromId(id);
  const el = document.getElementById("add_activity");
  if (el) new bootstrap.Modal(el).show();
}

function openDelete(id) {
  activityModalRef.value?.openDelete(id);
}

function onSaved() {
  tableRef.value?.reload?.();
}

function exportCsv() {
  const header = ["Title", "Type", "Status", "Owner", "Link Type", "Link ID", "Due At", "Created At"];
  const rows = (store.items || []).map((activity) => [
    activity.title || "",
    activity.type || "",
    activity.status || "",
    [activity.owner?.first_name, activity.owner?.last_name].filter(Boolean).join(" ") || activity.owner_name || "",
    activity.link_type || "",
    activity.link_id || "",
    activity.due_at || "",
    activity.created_at || "",
  ]);

  const csv = [header, ...rows]
    .map((row) => row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `crm-activities-${moment().format("YYYY-MM-DD")}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

onMounted(() => {
  store.load();
});
</script>


